<template>
  <div class="web-v footer-bottom">
    <div class="bottombar">
      <div class="left-items">
        <a-button
          @click.prevent="handlePrevPress()"
          v-if="formStep === 2 || formStep === 3"
          class="checkout-button"
        >
          ← Previous
        </a-button>
        <div v-if="formStep === 1" class="hidden-button"></div>
      </div>

      <div class="step-header" v-if="formStep === 1">
        Drag Marker PIN to Your Location
      </div>
      <div class="step-header" v-if="formStep === 2">Personal Details</div>
      <div class="step-header" v-if="formStep === 3">Payment</div>

      <div class="right-items">
        <a-button
          @click.prevent="handleNextPress()"
          v-if="formStep === 1"
          class="checkout-button"
        >
          Next →
        </a-button>

        <a-button
          @click.prevent="$emit('submit-order')"
          v-if="formStep === 2"
          class="checkout-button"
        >
          Confirm Details →
        </a-button>

        <a-button
          @click.prevent="$emit('place-order')"
          v-if="formStep === 3"
          class="checkout-button green"
        >
          Place Order →
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "WizardFooter",

  data() {
    return {
      showFooter: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    ...mapGetters(["cartItems", "locationMarker", "formStep"]),
  },
  methods: {
    ...mapActions(["updateStep"]),
    handleNextPress() {
      if (this.formStep === 1) {
        if (this.locationMarker === null) {
          this.$notification.error({
            message: "Please Pin Your Location",
            description: "Locate your address in map before ordering!",
          });
        } else {
          this.updateStep(2);
        }
      }
    },
    handlePrevPress() {
      if (this.formStep === 3) {
        this.updateStep(2);
      } else if (this.formStep === 2) {
        this.updateStep(1);
      }
    },
    onScroll() {
      this.windowTop = window.top.scrollY;

      if (this.windowTop >= 200) {
        this.showFooter = true;
      } else if (this.windowTop <= 200) {
        this.showFooter = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.footer-bottom {
  background: rgba(255, 255, 255, 1);
  transition: bottom 0.4s;

  &.web-v {
    position: fixed;
    width: 70%;
    transform: translateX(-50%);
    margin-left: 35%;
    bottom: 20px;
    z-index: 99;
    border-radius: 10px;
    box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
  }
}

.bottombar {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.left-items {
  display: inline-block;
}

.right-items {
  display: inline-block;
}

.checkout-button {
  display: inline-block;
  font-size: 13px;
  padding: 10px;
  margin: 0px 20px;
  background-color: $brand-color;
  color: white;
  height: auto;
  width: 145px;
  cursor: pointer;
  font-family: $main-font;
  text-transform: uppercase;
  border-radius: 4px;
  &.green {
    background-color: #60b246;
  }

  &.green:hover {
    border-color: #60b246;
  }
}

.hidden-button {
  width: 145px;
}

@media only screen and (max-width: 768px) {
  .header {
    display: block !important;
    a {
      display: block !important;
    }
    .button-icon {
      display: block !important;
    }
  }

  .header-wrap {
    .container {
      margin: 0;
      width: 100%;
    }
  }
  .header {
    .custom-menu {
      li {
        padding: 0 15px;
        a {
          font-size: 12px;
        }
      }
    }
  }
}

.step-header {
  font-family: $main-font;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  text-align: center;
}

@media only screen and (max-width: 740px) {
  .footer-bottom {
    &.web-v {
      position: fixed;
      width: 90%;
    }
  }
  .bottombar {
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  .checkout-button {
    display: inline-block;
    font-size: 12px;
    padding: 10px 5px;
    background-color: $brand-color;
    color: white;
    height: auto;
    width: 115px;
    cursor: pointer;
    font-family: $main-font;
    text-transform: uppercase;
    border-radius: 4px;
    &.green {
      background-color: #60b246;
    }
  }

  .hidden-button {
    width: 0px;
  }

  .step-header {
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
